import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';

import {
  LOAN_APPLICATION_FETCH_START,
} from '../../actions/types'

import {
  loanApplicationFetchSuccess,
  loanApplicationFetchFailed,
} from '../../actions'

import { getLoanApplication } from '../../requesters/loanApplication'

function* loanApplicationFetch(action) {
  const { response, error } = yield call(getLoanApplication, action.payload.id)

  if (response) {
    yield put(loanApplicationFetchSuccess(response))
  } else {
    yield put(loanApplicationFetchFailed(error))
  }
}

export function* watchLoanApplicationFetch() {
  yield takeLatest(LOAN_APPLICATION_FETCH_START, loanApplicationFetch);
}
